



































































import { Vue, Component, Prop } from 'vue-property-decorator'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import shareImgPage from './shareImgPage.vue'
import RichText from '@ivy/fts/comps/RichText.vue'
@Component({
  components: {
    RichText,
  },
})
export default class ParentTypeTestResult extends Vue {
  @Prop({ default: [] }) result
  @Prop() share_pic_url: string
  report_text: any = ''
  userInfo: any = {}
  mods: any = []
  async mounted() {
    // await this.$store.login()
    this.mods = (this.result && this.result.length !== 0 && this.result) || []
    this.report_text = this.result
      .filter(f => {
        return f.isHighest
      })
      .map(re => re.title)
      .join('、')
  }
  showShareMod() {
    showDiv(shareImgPage, {
      picUrl: this.share_pic_url,
      tipText: '长按海报保存到本地或分享给好友',
    })
  }
}
